import { Request } from 'fetchboi'

export const getTraining = Request.register({
    endpoint: '/trainings/:id',
    method: 'get',
    useAuthentication: true
})

export const getTrainings = Request.register({
    endpoint: '/trainings',
    method: 'get',
    useAuthentication: true
})

export const getTrainingByCompany = Request.register({
    endpoint: '/trainings?companyId=:companyId',
    method: 'get',
    useAuthentication: true
})

export const getTrainingByPosition = Request.register({
    endpoint: '/trainings?companyId=:companyId&positionId=:positionId',
    method: 'get',
    useAuthentication: true
})

export const addTrainings = Request.register({
    endpoint: '/trainings',
    method: 'post',
    useAuthentication: true
})

export const editTraining = Request.register({
    endpoint: '/trainings/:id',
    method: 'put',
    useAuthentication: true
})

// export const deleteTraining = Request.register({
//     endpoint: '/trainings/:id',
//     method: 'delete',
//     useAuthentication: true
// })


// WEBPACK FOOTER //
// ./src/requests/trainings.js